<template>
  <div
    :class="{
      'nav-menu': true,
      hide: !isExpend,
    }"
  >
    <div class="expendCon" @click="isExpend = !isExpend" v-show="isExpend">
      <span class="iconfont icon-zuojiantou"></span>
    </div>
    <div class="expendCon" @click="isExpend = !isExpend" v-show="!isExpend">
      <span class="iconfont icon-youjiantou"></span>
    </div>
    <div class="navInner">
      <div class="userInfo">
        <el-dropdown placement="bottom-start" @command="changeMenu">
          <img class="userHeader" :src="userInfo?.avatar" />
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="退出登录">退出登录</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <div class="userNameCon" v-show="isExpend">
          <p class="name">{{ userInfo?.name }}</p>
          <p class="job">{{ userInfo?.tec_type }}</p>
        </div>
      </div>
      <div class="menuItem" v-for="(item, index) in menuArr" :key="index">
        <div class="secondMenu">
          <span
            :class="{
              [item.icon]: true,
              actived:
                !isExpend &&
                item.children.some((child) => child.path === activeName),
            }"
          ></span>
          <span v-show="isExpend">{{ item.label }}</span>
        </div>
        <div class="thirdMenuCon" v-show="isExpend">
          <div
            class="thirdMenu"
            v-for="(child, num) in item.children"
            :key="num"
          >
            <span
              :class="{
                actived: child.path === activeName,
              }"
              @click="changeRoute(child.path)"
              >{{ child.label }}</span
            >
          </div>
        </div>
      </div>
    </div>
    <div class="navFoot">
      <span
        @click="
          $router.push({
            name: 'ReceptionHall',
          })
        "
        ><span v-show="isExpend">接单大厅</span>
        <span class="iconfont icon-youshangjiantou-yuan-xian"></span
      ></span>
    </div>
  </div>
</template>

<script>
import { logout } from "@/https/login";
export default {
  name: "navMenu",
  props: {
    menuArr: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      isExpend: true,
      activeName: null,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo;
    },
  },
  watch: {
    $route(to) {
      this.activeName = to.meta.activeName;
    },
  },
  methods: {
    changeRoute(name) {
      this.$router.push({
        name,
      });
    },
    async changeMenu(name) {
      try {
        switch (name) {
          case "退出登录":
            await logout();
            this.$store.commit("setUser", {});
            localStorage.removeItem("userInfo");
            this.$router.push({
              name: "Login",
            });
            break;
          default:
            break;
        }
      } catch (e) {}
    },
  },
};
</script>

<style scoped lang="less">
.nav-menu {
  background: #1d2129;
  padding: 25px;
  position: relative;
  transform: translateX(0);
  width: 238px;
  height: 100%;
  display: flex;
  flex-direction: column;
  .expendCon,
  .expendCon2 {
    position: absolute;
    padding: 8px 3px;
    right: 0;
    top: 39px;
    background: #35383a;
    border-radius: 4px 0px 0px 4px;
    cursor: pointer;
    .iconfont {
      color: #86909c;
    }
  }
  .navInner {
    flex: 1;
    overflow-y: auto;
    .userInfo {
      display: flex;
      align-items: center;

      position: relative;
      margin-bottom: 70px;
      .userHeader {
        width: 48px;
        height: 48px;
        border-radius: 50px;
        margin-right: 8px;
      }
      .userNameCon {
        .name {
          font-weight: 600;
          font-size: 18px;
          color: #ffffff;
          margin-bottom: 4px;
        }
        .job {
          font-weight: 400;
          font-size: 14px;
          color: #c9cdd4;
        }
      }

      &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        background: #35383a;
        bottom: -22px;
      }
    }
    .menuItem {
      margin-bottom: 30px;
      position: relative;
      .secondMenu {
        color: #c9cdd4;
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .iconfont {
          margin-right: 15px;
          font-size: 20px;
          vertical-align: middle;
          &.actived {
            color: #029e17;
          }
        }
      }
      .thirdMenuCon {
        display: flex;
        flex-wrap: wrap;
        .thirdMenu {
          width: 50%;
          font-size: 14px;
          color: #86909c;
          margin-bottom: 12px;
          span {
            cursor: pointer;
            &:hover {
              color: #029e17;
            }
          }
          span.actived {
            color: #029e17;
          }
        }
      }
      &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 1px;
        background: #35383a;
        bottom: -15px;
      }
    }
    .menuItem:last-child {
      &:after {
        content: "";
        position: absolute;
        width: 100%;
        height: 0;
      }
    }
  }
  .navFoot {
    height: 25px;
    line-height: 25px;
    color: #86909c;
    > span {
      cursor: pointer;
    }
    .iconfont {
      font-size: 18px;
      vertical-align: middle;
    }
  }
}
.hide {
  width: 120px;
  align-items: center;
  .userHeader {
    margin-right: 0 !important;
  }
  .menuItem {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 53px;
    .iconfont {
      margin-right: 0 !important;
    }
  }
}
</style>
